<template>
  <div>
    <h2 class="md:text-5xl md:-mt-12 text-4xl font-bold leading-tight text-center" :class="subtitle ? 'mb-4' : 'mb-16'">
      Your rides are full of data.
      <br class="md:block hidden" />
      See what they mean.
    </h2>
    <p v-if="subtitle" class="lead text-muted max-w-2xl mx-auto mb-16 text-center">{{ subtitle }}</p>

    <div class="flex flex-wrap mt-16">
      <div v-for="(feature, index) in features" :key="index" class="md:w-1/2 lg:w-1/3 flex w-full mb-8">
        <div class="flex-shrink-0 w-16 text-center">
          <svg class="svg-icon text-primary">
            <use :xlink:href="`#icon-${feature.icon}`"></use>
          </svg>
        </div>
        <div class="w-auto pr-6">
          <h3 class="mb-2 text-lg font-bold">{{ feature.title }}</h3>
          <p class="text-sm">
            {{ feature.description }}
          </p>
        </div>
      </div>
    </div>

    <div class="my-6 font-bold text-center">
      <router-link class="inline-block py-1" :to="{ name: 'training-glossary' }" title="Cycling and Training Glossary">& more&hellip;</router-link>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: false,
      default: 'Your rides are full of data. See what they mean.'
    },
    subtitle: {
      type: String,
      required: false,
      default: ''
    }
  },

  data() {
    return {
      features: [
        {
          title: 'Form & Fitness',
          icon: 'arrow-up-right',
          description: 'Keep track of your fitness, fatigue and your current form. Form prediction helps you to plan ahead for your next event or a race.'
        },
        {
          title: 'Weekly Training Status',
          icon: 'calendar',
          description: 'See your progress week by week – Training status will evaluate your weekly progress and show you how productive was your training.'
        },
        {
          title: 'Training Stress Score®',
          icon: 'progress',
          description: 'Training Stress Score is an estimate of overal training load for a given training session, calculated from its duration and intensity.'
        },
        {
          title: 'Normalized Power®',
          icon: 'normalized-power',
          description: 'Normalized Power smooths out the variability in the power of your ride caused by different factors (e.g. terrain, wind, grade, etc.)'
        },
        {
          title: 'Intensity Factor®',
          icon: 'intensity',
          description: 'Use Intensity Factor to easily see how hard was a ride compared to your overall fitness.'
        },
        {
          title: 'Variability Index',
          icon: 'variability-index',
          description: 'Variability Index shows how evenly paced was your power output during your ride or race.'
        },
        {
          title: 'Power Analysis',
          icon: 'power',
          description: 'Explore your power curve and keep track of your records - see how your maximum power change over time.'
        },
        {
          title: 'Critical Power (CP)',
          icon: 'power',
          description:
            'Critical Power estimates the power you can hold for long efforts, modeled from your everyday rides - a more complete read on your endurance than FTP alone.'
        },
        {
          title: "W' (Anaerobic Capacity)",
          icon: 'battery',
          description: "W' is your anaerobic battery - the energy you can spend above Critical Power on attacks, climbs and sprints before you need to recover."
        },
        {
          title: 'Automatic FTP Detection',
          icon: 'medal',
          description: 'FormBeat detects when your FTP has improved and suggests an update - so your zones and analysis stay accurate without a dedicated test.'
        },
        {
          title: 'Zone Analysis',
          icon: 'zone-analysis',
          description: 'Analyze the time you spend in each heart rate or power zone.'
        },
        {
          title: 'Aerobic Efficiency',
          icon: 'arrow-up-right',
          description: 'Track how your watts per heartbeat improve over time on endurance rides. A rising trend means a stronger aerobic engine.'
        }
        // {
        //   title: 'Activity Analysis',
        //   icon: 'medal',
        //   description: 'Easily compare the characteristics of each ride with other rides from the same period.'
        // }
      ]
    }
  }
}
</script>

<style lang="postcss" scoped></style>
